import React, {
    useCallback,
    useContext,
    useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import SgWebchatUtil from 'sg-webchat-util';
import { Button } from '@jutro/components';
import CommonConstants from 'sg-common-constants';
import CepConstants from 'sg-cep-constants';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import { useSgTrackPageName } from 'saga-modules';
import { useHistory } from 'react-router-dom';
import messages from './SgCepError.messages';

function SgCepError(props) {
    const {
        errorCodeT, productCode
    } = props;
    const translator = useContext(TranslatorContext);
    const history = useHistory();
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';

    useSgTrackPageName(CepConstants.PAGE_NAMES.ERROR_CONTACT_US);

    const goHome = useCallback(() => {
        history.push('/home');
    }, [history]);

    const shouldRenderProductSpecificVersion = useMemo(() => {
        return productCode && errorCodeT === CommonConstants.SG_ERROR_CODES.SAGA_PAYMENT_FAILED;
    }, [errorCodeT, productCode]);

    const productSpecificContactDetailsContainer = useCallback((product) => {
        const openHours = SgWebchatUtil.openHours(product);
        return (
            <>
                <div className={`sgErrorContactDetails ${product}`}>
                    {SgCepLobSpecificUtil.getProductSpecificContactDetails(product, translator, isMobile)}
                    <div className="sgErrorContactLinesOpen">
                        {SgCepLobSpecificUtil.getProductSpecificOpenLinesWording(product, translator)}
                    </div>
                    <Button
                        id={`${openHours ? 'faqChatNow' : 'faqLeaveMessage'}${product}`}
                        type="button"
                        className="saga-intercom sgButton sgPrimaryButton"
                        onClick={() => { SgWebchatUtil.trackChat(); }}
                    >
                        { openHours
                            ? translator(messages.ChatOnline) : translator(messages.LeaveMessage)}
                    </Button>
                </div>
            </>
        );
    }, [translator, isMobile]);

    const commonVersion = useMemo(() => {
        return (
            <>
                <div className="sgErrorContactDetailsContainer">
                    {productSpecificContactDetailsContainer(CommonConstants.MOTOR_PRODUCT_CODE)}
                    {productSpecificContactDetailsContainer(CommonConstants.HOME_PRODUCT_CODE)}
                    {productSpecificContactDetailsContainer(CommonConstants.TRAVEL_PRODUCT_CODE)}
                    {productSpecificContactDetailsContainer(CommonConstants.PRIVATE_MEDICAL_INSURANCE_CODE)}
                </div>
            </>
        );
    }, [isMobile]);

    return (
        <div className="sgPageContainer sgErrorPageContent">
            <h1>{translator(messages.ErrorTitle)}</h1>
            <p className="sgSubTitle">{translator(messages.SorryIssueHasOccurred)}</p>
            <p>{translator(messages.ContactUs)}</p>
            {shouldRenderProductSpecificVersion && (
                <div className="sgErrorSingleContactDetailsContainer">
                    {productSpecificContactDetailsContainer(productCode)}
                </div>
            )}
            {!shouldRenderProductSpecificVersion && (commonVersion)}
            <Button className="sgButton sgTransactionButton" onClick={goHome}>
                {translator(messages.BackToHome)}
            </Button>
        </div>
    );
}

export default SgCepError;
